import { useQuery } from '@tanstack/react-query';

import { type MarketingRouterSignificanceQuery, getMarketingRouterSignificance } from '~/services/PromoService';

export const marketingRouterSignificanceQueryKeys = {
  all: ['marketing-router-significance'] as const,
  detail: (marketingRouterId: string, query: MarketingRouterSignificanceQuery) =>
    [...marketingRouterSignificanceQueryKeys.all, marketingRouterId, query] as const,
};

export function useMarketingRouterSignificance({
  marketingRouterId,
  query,
  enabled = true,
}: {
  marketingRouterId: string | undefined;
  query: MarketingRouterSignificanceQuery;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: marketingRouterSignificanceQueryKeys.detail(marketingRouterId ?? '', query),
    queryFn: async ({ signal }) => {
      if (!marketingRouterId) {
        throw new Error('marketingRouterId is required');
      }
      const response = await getMarketingRouterSignificance(marketingRouterId, query, { signal });
      return response.result;
    },
    enabled: enabled && Boolean(marketingRouterId),
  });
}
